// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"dadb8c04","213":"16587602"}[chunkId] + ".chunk.js";
};